import { supabase } from '@/integrations/supabase/client'

export async function invokeAdmin(functionName: string, body: unknown) {
  const { data: { session } } = await supabase.auth.getSession()

  // Debug logging
  console.log('invokeAdmin called:', {
    functionName,
    body,
    hasSession: !!session,
    hasAccessToken: !!session?.access_token,
    tokenLength: session?.access_token?.length || 0
  })
  console.log('Body being sent:', JSON.stringify(body))

  if (!session?.access_token) {
    throw new Error('No valid session found - user not authenticated')
  }

  // Explicitly pass the authorization header
  const result = await supabase.functions.invoke(functionName, {
    body,
    headers: {
      Authorization: `Bearer ${session.access_token}`
    }
  })

  // Debug the result
  console.log('invokeAdmin result:', result)
  console.log('Raw result data:', result.data)
  console.log('Raw result error:', result.error)

  // If there's an error, sanitize the error message for users
  if (result.error) {
    // Always provide a generic error message to prevent technical leaks
    const genericError = new Error('Erro de comunicação com o servidor')
    genericError.name = 'ServerError'

    // Check if there's a more specific error message in the response data for logging only
    if (result.data && typeof result.data === 'object' && 'error' in result.data) {
      console.log('Server error details:', (result.data as any).error)
    }

    result.error = genericError
  }

  return result
}


